// ホームの「スタッフ訪問」入口（2026-09-11・#392）。
// 担当店の company.is_houmon=1 のときだけ出す。専用バッグに入らない大物・大量向け。
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Post } from './Post';

export const StaffVisitEntry = ({ style }) => {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    Post('post', '/order/staff_visit_info.php', {}).then((r) => { if (alive && r && r.result === 1) setInfo(r); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!info || Number(info.enabled) !== 1) return null;
  return (
    <div className="div_btn" onClick={() => navigate('/staff_visit')}
      style={{ border: '1px solid #ddd', borderRadius: 12, padding: '14px 16px', background: '#fff', display: 'flex', alignItems: 'center', gap: 12, textAlign: 'left', ...style }}>
      <div style={{ fontSize: 28, flex: 'none' }} aria-hidden="true">🚪</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 15 }}>スタッフ訪問</div>
        <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>専用バッグに入らないふとん・カーテン・衣替えのまとめ出しなど。スタッフがご自宅へ伺います。</div>
      </div>
      <div style={{ color: '#999', flex: 'none' }}>›</div>
    </div>
  );
};
